import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { APP_NAME } from "./constants";

// ログをつぶす
// https://qiita.com/qrusadorz/items/47152545ac82b999b214
if (process.env.REACT_APP_TARGET_ENV === "Production") {
  console.debug = () => {};
  console.info = () => {};
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

document.documentElement.lang = "ja";
document.title = APP_NAME;
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
